import { render, staticRenderFns } from "./EatingInputGroup.vue?vue&type=template&id=3447611e&scoped=true&"
import script from "./EatingInputGroup.vue?vue&type=script&lang=ts&"
export * from "./EatingInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3447611e",
  null
  
)

export default component.exports